export default "__VITE_ASSET__BdCPdtwt__"